import {TurnstileContext} from '@cohort/shared-frontend/contexts/TurnstileContext';
import type {TurnstileInstance} from '@marsidev/react-turnstile';
import {Turnstile} from '@marsidev/react-turnstile';
import {useCallback, useRef, useState} from 'react';

type TurnstileProviderProps = {
  action: string;
  siteKey: string;
  children: React.ReactNode;
};

const RETRYABLE_ERRORS = /^(crashed|undefined_error|110600|(102|103|104|106|300|600)\d{3})$/u;

export const TurnstileProvider: React.FC<TurnstileProviderProps> = ({
  action,
  siteKey,
  children,
}) => {
  const ref = useRef<TurnstileInstance | null>(null);
  const [token, setToken] = useState<string>();

  const getToken = useCallback(async () => {
    if (token) {
      // Reset the turnstile instance to avoid re-using the same token
      ref.current?.reset();
      return token;
    }
    const newToken = await ref.current?.getResponsePromise();

    if (!newToken) {
      ref.current?.reset();
      return getToken();
    }
    // Reset the turnstile instance to avoid re-using the same token
    ref.current?.reset();
    return newToken;
  }, [token]);

  return (
    <TurnstileContext.Provider value={{getToken}}>
      <Turnstile
        id="turnstile-global"
        ref={ref}
        siteKey={siteKey}
        options={{size: 'invisible', action}}
        onSuccess={newToken => setToken(newToken)}
        onError={(code?: string | number) => {
          if (code !== undefined && !RETRYABLE_ERRORS.test(String(code))) {
            return false;
          }
          return true;
        }}
      />
      {children}
    </TurnstileContext.Provider>
  );
};
